import { useQuery } from "react-query";
import { getData } from "../newApis/apiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

type TQuery = {
  purchase_order_detail_id: number;
};

const getPurchaseOrderDocuments = async ({
  purchase_order_detail_id,
}: TQuery) => {
  const data = await getData(
    `${ajaxEndpoints.GET_PURCHASE_ORDER_DOCUMENTS}/${purchase_order_detail_id}`,
  );
  return data?.data;
};

export default function usePurchaseOrderDocuments({
  purchase_order_detail_id,
}: TQuery) {
  return useQuery(
    [{ purchase_order_detail_id }, "getPurchaseOrderDocuments"],
    getPurchaseOrderDocuments,
  );
}
